export default {
    AUTO_SAVE_TIME_INTERVAL: 30 * 1000, // 30 seconds
    BLOCK_WIDTH: 600,
    MAXIMUM_ALLOWABLE_COLUMN_SIZE: 1,
    MAXIMUM_ALLOWABLE_BLOCK_COLUMN_NUMBERS: 4,
    MAXIMUM_ALLOWABLE_BLOCK_COLUMN_ITEMS: 8,
    MINIMUM_ALLOWABLE_COLUMN_SIZE: 1 / 6,
    MINIMUM_ALLOWABLE_COLUMN_SIZE_STRING: '1/6',
    MINIMUM_ALLOWABLE_BLOCK_PADDING: 0,
    MAXIMUM_ALLOWABLE_BLOCK_PADDING: 50,
    MAXIMUM_ALLOWABLE_GUTTER: 50,
    IMAGE_PLACEHOLDER_HEIGHT: 150,
    MAXIMUM_ALLOWABLE_BUTTON_BORDER_RADIUS: 10,
    MINIMUM_ALLOWABLE_BROWSER_WIDTH: 1100,
    MINIMUM_ALLOWABLE_BROWSER_HEIGHT: 440,
    TESTING_DOMAIN_INDICATOR: 'http://localhost',
    INTERNAL_DOMAIN_INDICATOR: 'bananatag.com',
    EVENT_EMITTER_EVENT_TRIGGERS: {
        TRIGGER_SAVE: 'triggerSave',
        TRIGGER_AUTO_SAVE: 'triggerAutoSave',
    },
    EVENT_EMITTER_EVENTS: {
        MOUNTED: 'mounted',
        IFRAME_READY: 'iframeReady',
        NOTIFICATION: 'notification',
        ERROR: 'error',
        SAVE: 'save',
        SAVE_AS_TEMPLATE: 'saveAsTemplate',
        SAVE_BLOCK: 'saveBlock',
        DOWNLOAD: 'download',
        SEND_TEST: 'sendTest',
        CHANGES_EXIST_STATUS: 'changesExistStatus',
        SHARE_DRAFT: 'shareDraft',
        LEAVE_DRAFT: 'leaveDraft',
        PERSONALIZATION_EDIT: 'personalizationEdit',
        PERSONALIZATION_DOWNLOAD_CSV: 'personalizationDownloadCsv',
        GET_SINGLE_USE_TAG_DATA: 'getSingleUseTagData',
        // Another connected client saved the document.
        REMOTE_SAVED: 'remoteSaved',
        // The connection dropped, so this client may have missed other clients' edits.
        LIVE_SYNC_LOST: 'liveSyncLost',
    },
    surveyTypes: {
        SOCIAL_REACTION_EMOJI: 'SOCIAL_REACTION_EMOJI',
        SOCIAL_REACTION_LIKE: 'SOCIAL_REACTION_LIKE',
        PULSE_RANGE_STARS: 'PULSE_RANGE_STARS',
        PULSE_RANGE_FACES: 'PULSE_RANGE_FACES',
        PULSE_RANGE_NUMBERS: 'PULSE_RANGE_NUMBERS',
        PULSE_BINARY_THUMBS_UP_AND_DOWN: 'PULSE_BINARY_THUMBS_UP_AND_DOWN',
        PULSE_BINARY_YES_AND_NO: 'PULSE_BINARY_YES_AND_NO',
        PULSE_BINARY_CHECKBOX_CONFIRM: 'PULSE_BINARY_CHECKBOX_CONFIRM',
        ENPS: 'ENPS',
    },
    SURVEY_ICONS_ELEMENTS_PADDING: '0 10px',
    MAX_IMAGE_UPLOAD_FILE_SIZE: 10, // MB
    MAX_GIF_UPLOAD_FILE_SIZE: 5, // MB
    IMAGE_LIBRARY_LOAD_BATCH_SIZE: 16,
    THIRD_PARTY_SB_POSTS_LOAD_BATCH_SIZE: 16,
    // we understand that 102000 is not 102 KB, but it is defined like this in gmail extention
    // so we should be consistent in both projects and also give a bit of margin
    GMAIL_MAX_CONTENT_SIZE: 102000,
    HTML_MAX_CONTENT_SIZE: 5 * 1024 * 1024,
    VERSION_HISTORY_LOAD_BATCH_SIZE: 100,
    BANANATAG_OFFICE_IPS: ['24.87.213.14', '184.68.41.58', '34.210.141.180', '54.214.143.93'],
    SAVE_TIMEOUT: 60000, // ms that can elapse before save is considered failed
    MAXIMUM_QUICKBLOCK_LENGTH: 40, // 40 characters
};
